import React, {useEffect, useState} from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import {majors} from 'Utils/majors';
import {DayInput, SelectInput, TextAreaInput, TextInput} from 'Input/Input';
import {AiOutlineClose} from 'react-icons/ai';
import {push, validateName, validateUserName} from 'Utils/validation'
import s from '../../styles/StudentProfile.module.scss'
import {Root} from 'Root'
import EditProfilePic from './EditProfilePic';
import {Tile} from 'Components/Tile/Tile'
import Spinner from 'react-bootstrap/esm/Spinner'
import avi from 'Static/default-avi.png'
import ImgUploader from 'Components/Input/ImgUploader';
import {deleteImageCDN, validateFiles} from 'Utils/media'
import {RiDeleteBin2Line, RiFile2Fill} from 'react-icons/ri';
import {FaLink} from 'react-icons/fa';
import {Link} from 'react-router-dom'
import {setSessionCookie} from "../../../../Utils/sessions";

export const EditAboutMe = ({session, profile, refreshSession }) => {
    const [loading, setLoading] = useState(false)

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <div className='d-flex justify-content-center'>
                {loading
                    ? <Spinner className={s.loading} style={{color: "rgb(16, 142, 115)"}} animation="border"
                               role="status"/>
                    : <div className={s.avi}
                           style={{backgroundImage: `url(${session.photo || avi})`, backgroundSize: 'cover'}}/>}
            </div>
            <EditProfilePic session={session} refreshSession={refreshSession} loading={loading}
                            setLoading={setLoading}/>
            <EditNameForm session={session} profile={profile} refreshSession={refreshSession} />
            <hr/>
            <EditUsernameForm session={session} profile={profile} refreshSession={refreshSession}/>
            <hr/>
            <EditMajorForm session={session} profile={profile} refreshSession={refreshSession}/>
            <hr/>
            <EditBioForm session={session} profile={profile} refreshSession={refreshSession}/>
            <hr/>
            <EditLocationForm session={session} profile={profile} refreshSession={refreshSession}/>
        </Card.Body>
    </Card>
    </>
};

export const EditSkills = ({session}) => {
    const [skills, setSkills] = useState(null)
    const [skill, setSkill] = useState('')
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)
    const handleCancel = () => {
        setSkill(null);
        setEditing(false);
    }
    const handleEdit = () => {
        if (editing) {
            setError(null)
            setSkill(null)
            setEditing(false)
        } else {
            setEditing(true)
        }
    }

    function getSkills() {
        setError(null)
        Root.userApi.getAttribute("skills", session.jwt)
            .then(res => setSkills(res.data)).catch(
            () => setError("Something went wrong, please try again later"))
    }

    useEffect(() => {
        getSkills()
    }, [])

    const handleAdd = () => {
        setError(null)
        if (!skill) {
            return
        }
        Root.userApi.addAttribute({attribute: "skills", newSkill: {skill: skill}}, session.jwt)
            .then(() => {
                getSkills()
                setSkill(null)
            }).catch(
            () => setError("Unable to add. Please try again later"))
    }

    const handleDelete = (id) => {
        setError(null)
        Root.userApi.removeAttribute("skills", id, session.jwt)
            .then(res => getSkills()).catch(
            () => setError("Unable to delete. Please try again later"))
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            {skills ? skills.map((skill, idx) => {
                return <Tile className='me-2' color='purple'>{skill.skill} {' '}
                    {editing && <Button className='btnLink p-0' onClick={() => handleDelete(skill.id)}><AiOutlineClose color={'red'}/></Button>}
                </Tile>
            }) : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            <Card.Text>
                {editing &&
                    <TextInput errors={formErrors} name="skill" value={skill} onChange={(e) => setSkill(e.target.value)}
                               placeholder="Add a skill"/>}
            </Card.Text>
            <p className='form-error'>{error}</p>
        </Card.Body>
        {editing && <>
            <Card.Footer className=' d-flex justify-content-end'>
                <Button className='btnOutline' onClick={handleCancel}>Done</Button>
                <Button className='btnFill ms-2' onClick={handleAdd}>Add</Button>
            </Card.Footer>
        </>}
    </Card>
    </>
};

export const EditInterests = ({session}) => {
    const [interests, setInterests] = useState(null)
    const [interest, setInterest] = useState('')
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)
    const handleCancel = () => {
        setInterest(null);
        setEditing(false);
    }
    const handleEdit = () => {
        if (editing) {
            setError(null)
            setInterest(null)
            setEditing(false)
        } else {
            setEditing(true)
        }
    }

    function getInterests() {
        setError(null)
        Root.userApi.getAttribute("interests", session.jwt)
            .then(res => setInterests(res.data)).catch(
            () => setError("Something went wrong, please try again later"))
    }

    useEffect(() => {
        getInterests()
    }, [])

    const handleAdd = () => {
        setError(null)
        if (!interest) {
            return
        }
        Root.userApi.addAttribute({
            attribute: "interests",
            newInterest: {interest: interest}
        }, session.jwt)
            .then(() => {
                getInterests()
                setInterest(null)
            }).catch(
            () => setError("Unable to add. Please try again later"))
    }

    const handleDelete = (id) => {
        setError(null)
        Root.userApi.removeAttribute("interests", id, session.jwt)
            .then(res => getInterests()).catch(
            () => setError("Unable to delete. Please try again later"))
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            {interests ? interests.map((interest, idx) => {
                return <Tile className='me-2' color='green'>{interest.interest} {' '}
                    {editing &&
                        <Button className='btnLink p-0' onClick={() => handleDelete(interest.id)}>
                            <AiOutlineClose color={'red'}/>
                        </Button>}
                </Tile>
            }) : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            <Card.Text>
                {editing && <TextInput errors={formErrors} name="interest" value={interest}
                                       onChange={(e) => setInterest(e.target.value)} placeholder="Add an interest"/>}
            </Card.Text>
            <p className='form-error'>{error}</p>
        </Card.Body>
        {editing && <>
            <Card.Footer className=' d-flex justify-content-end'>
                <Button className='btnOutline' onClick={handleCancel}>Nevermind</Button>
                <Button className='btnFill ms-2' onClick={handleAdd}>Add</Button>
            </Card.Footer>
        </>}
    </Card>
    </>
};


export const EditTestScores = ({session, profile, refreshSession}) => {
    const [request, setRequest] = useState({})
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)

    const handleEdit = () => {
        if (editing) {
            handleSave()
        } else {
            setEditing(true)
        }
    }

    function handleSave() {
        setError(null)
        Root.userApi.updateUser({basicInformation: {gpa: request.gpa}}, session.jwt)
            .then(() => {
                refreshSession()
            }).catch(() => setError("Unable to save changes"))
        setEditing(false)
    }

    function handleChange(event) {
        const {name, value} = event.target;
        setRequest((prevState) => ({...prevState, [name]: value}));
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            <Card.Text>
                {editing ?
                    <TextInput errors={formErrors} name="gpa" value={request.gpa || ''} onChange={handleChange}
                               placeholder="4.0 scale" type={'number'}/>
                    : <span className='text-muted d-block'>{profile.gpa || ''}</span>}
            </Card.Text>
            <p className='form-error'>{error}</p>
        </Card.Body>
    </Card>
    </>
};

export const EditCareerHistory = ({session, type}) => {
    const [jobs, setJobs] = useState(null)
    const [job, setJob] = useState({})
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)
    const handleCancel = () => {
        setEditing(false);
        setJob({});
    }
    const isJobType = () => {
        return type === 'job_positions'
    }

    useEffect(() => {
        getJobs()
    }, [])

    const handleAdd = () => {
        setError(null)

        if ("endDate" in job && job.endDate.length === 0) {
            delete job.endDate
        }

        if (isJobType() && (!job.company || !job.role || !job.startDate)) {
            setError("Please fill out company, position and start date")
            return;
        } else if (!job.role || !job.startDate) {
            setError("Please fill out position and start date")
            return
        }

        if (isJobType()) {
            Root.userApi.addAttribute(
                {
                attribute: "job_positions",
                newJobPosition: job
            }, session.jwt)
                .then(() => {
                    getJobs()
                    setJob({})
                    setEditing(false)
                }).catch(
                () => setError("Something went wrong, please try again later"))
        } else {
            Root.userApi.addAttribute(
                {
                    attribute: "experiences",
                    newExperience: job
                }, session.jwt)
                .then(() => {
                    getJobs()
                    setJob({})
                    setEditing(false)
                }).catch(
                () => setError("Something went wrong, please try again later"))
        }

    }

    function getJobs() {
        Root.userApi.getAttribute(type, session.jwt)
            .then(res => setJobs(res.data)).catch(
            () => setError("Something went wrong, please try again later"))
    }

    const handleEdit = () => {
        if (editing) {
            handleSave()
        } else {
            setEditing(true)
        }
    }

    function handleSave() {
        setError(null)
        setEditing(false)
    }

    function handleChange(event) {
        const {name, value} = event.target;
        setJob((prevState) => ({...prevState, [name]: value}));
    }

    const handleDelete = (id) => {
        setError(null)
        Root.userApi.removeAttribute(type, id, session.jwt)
            .then(res => getJobs())
            .then(() => setEditing(false))
            .catch(
            () => setError("Unable to delete. Please try again later"))
    }


    const Tile = ({job, idx}) => {
        return <div key={idx} className={`${s.editTile} mb-4`}>
      <span className='d-flex justify-content-between'>
        <p className='green mb-1 fs-16 trunc'>{job.role} {job.companyName && `at ${job.companyName}`}</p>
          {editing && <Button className='btnLink p-0' onClick={() => handleDelete(job.id)}><AiOutlineClose color={'red'}/></Button>}
      </span>
            <p className='text-muted mb-1 fs-13'>{job.startDate.split('-')[0]} to {job.endDate ? job.endDate.split('-')[0] : 'present'}</p>
            {job.details && <p className='fs-13'>{job.details}</p>}
        </div>
    }

    function handleChangeStartDate(selectedDay, modifiers, dayPickerInput) {
        setJob(prevState => ({...prevState, startDate: dayPickerInput.getInput().value}))
    }

    function handleChangeEndDate(selectedDay, modifiers, dayPickerInput) {
        setJob(prevState => ({...prevState, endDate: dayPickerInput.getInput().value}))
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            {jobs ? jobs.map((j, idx) => {
                return <Tile job={j} idx={idx}/>
            }) : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            {editing && <>
                {isJobType() &&
                    <TextInput containerClassName="mb-3" errors={formErrors} name="company" value={job.company || ''}
                               onChange={handleChange} label="Company" placeholder="Name"/>
                }

                <TextInput containerClassName="mb-3" errors={formErrors} name="role" value={job.role || ''}
                           onChange={handleChange} label="Position"
                           placeholder={isJobType() ? 'Name' : 'ex. President of Finance club'} maxLength={144}/>

                <DayInput format={'YYYY-MM-DD'} containerClassName={`mb-3 ${s.dayInput}`} errors={formErrors}
                          name={'startDate'} value={job.startDate} label="Start Date" onChange={handleChangeStartDate}
                          placeholder={'YYYY-MM-DD'}/>

                <DayInput format={'YYYY-MM-DD'} containerClassName={`mb-3 ${s.dayInput}`} errors={formErrors}
                          name={'endDate'} value={job.endDate} label="End Date (Optional)" onChange={handleChangeEndDate}
                          placeholder={'YYYY-MM-DD'}/>

                <TextAreaInput containerClassName="mb-3" errors={formErrors} name="details"
                               value={job.details || ''} onChange={handleChange} label="Description" placeholder=""
                               maxLength={600}/>

                <p className='form-error'>{error}</p>
            </>}
        </Card.Body>
        {editing && <>
            <Card.Footer className=' d-flex justify-content-end'>
                <Button className='btnOutline' onClick={handleCancel}>Cancel</Button>
                <Button className='btnFill ms-2' onClick={handleAdd}>Add</Button>
            </Card.Footer>
        </>}
    </Card>
    </>
};

export const EditAccomplishments = ({session}) => {
    const [awards, setAwards] = useState(null)
    const [award, setAward] = useState({})
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)
    const handleCancel = () => {
        setEditing(false);
        setAward({});
    }

    useEffect(() => {
        getAwards()
    }, [])

    const handleAdd = () => {
        setError(null)
        Root.userApi.addAttribute({
            attribute: "accomplishments",
            newAccomplishment: award
        }, session.jwt)
            .then(() => {
                getAwards()
                setAward({})
                setEditing(false)
            }).catch(
            () => setError("Unable to add. Please try again later"))
    }

    function getAwards() {
        Root.userApi.getAttribute("accomplishments", session.jwt)
            .then(res => setAwards(res.data)).catch(
            () => setError("Something went wrong, please try again later"))
    }

    const handleEdit = () => {
        if (editing) {
            handleSave()
        } else {
            setEditing(true)
        }
    }

    function handleSave() {
        setError(null)
        setEditing(false)
    }

    function handleChange(event) {
        const {name, value} = event.target;
        setAward((prevState) => ({...prevState, [name]: value}));
    }

    const handleDelete = (id) => {
        setError(null)
        Root.userApi.removeAttribute("accomplishments", id, session.jwt)
            .then((res) => getAwards())
            .then(() => setEditing(false))
            .catch(
            () => setError("Unable to delete. Please try again later"))
    }

    function handleChangeDay(selectedDay, modifiers, dayPickerInput) {
        setAward(prevState => ({...prevState, date: dayPickerInput.getInput().value}))
    }

    const Tile = ({award, idx}) => {
        return <div key={idx} className={`${s.editTile} mb-4`}>
        <span className='d-flex justify-content-between'>
          <p className='green mb-1 fs-16'>{award.title}</p>
            {editing &&
                <Button className='btnLink p-0' onClick={() => handleDelete(award.id)}><AiOutlineClose color={'red'}/></Button>}
        </span>
            <p className='text-muted mb-1 fs-13'>{award.month} {award.year} | {award.program}</p>
        </div>
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            {awards ? awards.map((a, idx) => {
                return <Tile award={a} idx={idx}/>
            }) : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            {editing && <>
                <TextInput containerClassName="mb-3" errors={formErrors} name="title" value={award.title || ''}
                           onChange={handleChange} label="Award" placeholder="Name"/>
                <TextInput containerClassName="mb-3" errors={formErrors} name="program" value={award.program || ''}
                           onChange={handleChange} label="From" placeholder="Organization"/>
                <DayInput format={'YYYY-MM-DD'} containerClassName={`mb-3 ${s.dayInput}`} errors={formErrors}
                          name={'date'} value={award.date} label="Date" onChange={handleChangeDay}
                          placeholder={'YYYY-MM-DD'}/>
                <p className='form-error'>{error}</p>
            </>}
        </Card.Body>
        {editing && <>
            <Card.Footer className=' d-flex justify-content-end'>
                <Button className='btnOutline' onClick={handleCancel}>Cancel</Button>
                <Button className='btnFill ms-2' onClick={handleAdd}>Add</Button>
            </Card.Footer>
        </>}
    </Card>
    </>
};

function removeEmptyValues(request) {
    var copy = {}
    Object.assign(copy, request)
    Object.keys(copy).forEach(key => {
        if (copy[key].length === 0) {
            delete copy[key]
        }
    })
    return copy
}

function handleUpdateUser(request, refreshSession, session, setError) {
    let filtered = removeEmptyValues(request)
    if (Object.keys(request).length > 0) {
        Root.userApi.updateUser({basicInformation: filtered}, session.jwt)
            .then(() => {
                refreshSession()
            })
            .catch((err) => {
                console.log(err);
                setError('Error saving changes')
            })
    } else {
        refreshSession()
    }
}

const EditNameForm = ({profile, session, refreshSession }) => {
    const [formErrors, setFormErrors] = useState({});
    const [request, setRequest] = useState({});
    const [editing, setEditing] = useState(false);
    const handleSave = () => {
        handleUpdateUser(request, refreshSession, session, (err) => setFormErrors({firstName: err}));
        setEditing(false)
    }

    const handleEdit = () => {
        if (editing && (!request.firstName && !request.lastName)) {
            setEditing(false)
            return;
        } else if (editing) {
            handleSave()
        } else {
            setEditing(true);
            setFormErrors({});
            setRequest({});
        }
    }

    function handleChange(event) {
        const {name, value} = event.target;
        setRequest(prevState => ({...prevState, [name]: value}));
    }

    useEffect(() => {
        setFormErrors({})
        const errors = validate(request)
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
        }
    }, [request])

    function validate() {
        var errors = {}
        if (request.firstName && !validateName(request.firstName)) {
            push(errors, 'firstName', 'Valid first name is required ')
        }
        if (request.lastName && !validateName(request.lastName)) {
            push(errors, 'lastName', 'Valid last name is required ')
        }
        return errors
    }

    return <div>
        {<div className='d-flex align-center justify-content-between'>
            <p className='mb-0 mt-3'><strong>Name</strong></p>
            <Link className='btnLink mb-3 fs-14' onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
        </div>}
        {editing ? <>
                <TextInput containerClassName='mb-2' errors={{}} label={'First Name'} name={'firstName'}
                           value={request.firstName} onChange={handleChange} type={'firstName'}
                           placeholder={profile.firstName}/>
                <TextInput errors={{}} label={'Last Name'} name={'lastName'} value={request.lastName}
                           onChange={handleChange} type={'lastName'} placeholder={profile.lastName}/>
            </>
            : <span className='text-muted d-block'>{profile.firstName} {profile.lastName}</span>}
        <p className='form-error mb-0'>{formErrors.firstName}</p>
        <p className='form-error mb-0'>{formErrors.lastName}</p>

    </div>;
}

const EditUsernameForm = ({session, refreshSession}) => {
    const [formErrors, setFormErrors] = useState({});
    const [username, setUsername] = useState(null);
    const [editing, setEditing] = useState(false);
    const handleSave = () => {
        handleUpdateUsername()
    }
    const handleChange = (e) => {
        setUsername(e.target.value)
    }

    function handleUpdateUsername() {
        if (username && !formErrors.userName) {
            Root.userApi.updateUsername(username, session.jwt)
                .then((newJWT) => {
                    Root.userApi.getSignedInUserInformation(newJWT.data).then(res => {
                        console.log(res.data)
                        let user = res.data?.user;
                        user.jwt = res.data?.jwt;
                        setSessionCookie(user);
                        refreshSession(user)
                        setEditing(false)
                    }).catch((err) => {})
                })
                .catch((err) => {
                    setFormErrors({userName: err.response?.data})
                    setEditing(false)
                })
        } else {
            setEditing(false)
        }
    }

    useEffect(() => {
        setFormErrors({})
        const errors = validate()
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
        }
    }, [username])

    function validate() {
        var errors = {}
        if (username && !validateUserName(username)) {
            push(errors, 'userName', 'Username must be at least 5 characters ')
        }
        return errors
    }

    const handleEdit = () => {
        if (editing) {
            handleSave()
        } else {
            setEditing(true);
            setFormErrors({});
            setUsername(null);
        }
    }

    return <div>
        {<div className='d-flex align-center justify-content-between'>
            <span className='mb-1'>
            <p className='mb-0 mt-3'><strong>Username</strong></p>
          </span>
            <Link className='btnLink mb-3 fs-14' onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
        </div>}
        {editing ?
            <TextInput errors={formErrors} name={'userName'} value={username} onChange={handleChange} type={''}
                       placeholder={`@${session.userName}`}/>
            : <span className='text-muted d-block'>@{session.userName}</span>}
    </div>;
}

const EditMajorForm = ({ session, refreshSession, profile }) => {
    const [formErrors, setFormErrors] = useState({});
    const [editing, setEditing] = useState(null);
    const [major, setMajor] = useState(null);

    const handleEdit = () => {
        if (editing) {
            handleUpdate()
        } else {
            setEditing(true);
            setFormErrors({})
        }
    }

    function handleUpdate() {
        if (major) {
            Root.userApi.updateUser({basicInformation: {major: major}}, session.jwt)
                .then(() => refreshSession())
                .then(() => setEditing(false))
                .catch(() => {
                    setFormErrors({major: 'Unable to save changes'});
                    setEditing(false);
                    setMajor(null)
                })
        } else {
            setEditing(false);
        }
    }

    function handleChange(event) {
        setMajor(event.target.value)
    }

    return <div>
        {<div className='d-flex align-center justify-content-between'>
            <span className='mb-1'>
            <p className='mb-0 mt-3'><strong>Major</strong></p>
          </span>
            <Link className='btnLink mb-3 fs-14' onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
        </div>}
        {editing ? <div className='d-flex justify-space-between align-center'>
            <SelectInput placeholder={majors[profile.major]} errors={formErrors} ordered={'false'} options={majors}
                         name={'major'} value={major} onChange={handleChange}/>
        </div> : <span className='text-muted d-block'>{majors[profile.major]}</span>}
        <span className='form-error'>{formErrors.major}</span>
    </div>;
}

const EditBioForm = ({profile, session, refreshSession}) => {
    const [formErrors, setFormErrors] = useState({});
    const [bio, setBio] = useState(profile.bio);
    const [editing, setEditing] = useState(false);
    const handleSave = () => {
        handleUpdateUser({bio: bio}, refreshSession, session, (err) => setFormErrors({bio: err}));
    }

    const handleEdit = () => {
        if (editing && (profile.bio === bio)) {
            setEditing(false);
        } else if (editing && (profile.bio !== bio)) {
            handleSave()
        } else {
            setEditing(true);
            setFormErrors({});
            setBio(profile.bio);
        }
    }

    return <div>

        {<div className='d-flex align-center justify-content-between'>
            <span className='mb-1'>
            <p className='mb-0 mt-3'><strong>About Me</strong></p>
          </span>
            <Link className='btnLink mb-3 fs-14' onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
        </div>}
        {editing ? <div className='d-flex justify-space-between align-center'>
            <TextAreaInput errors={{}} name={'bio'} value={bio} onChange={(e) => setBio(e.target.value)} type={'text'}
                           placeholder={`${profile.bio || ''}`}/>
        </div> : <span className='text-muted d-block'>{profile.bio || '-'}</span>}
        <span className='form-error'>{formErrors.bio}</span>
    </div>;
}

const EditLocationForm = ({profile, session, refreshSession}) => {
    const [formErrors, setFormErrors] = useState({});
    const [city, setCity] = useState(profile.city);
    const [state, setState] = useState(profile.state);
    const [editing, setEditing] = useState(false);
    const handleSave = () => {
        handleUpdateUser({city: city, state: state}, refreshSession, session, (err) => setFormErrors({location: err}));
    }

    const handleEdit = () => {
        if (editing && (profile.city === city && profile.state === state)) {
            setEditing(false);
        } else if (editing && (profile.city !== city || profile.state !== state)) {
            handleSave()
        } else {
            setEditing(true);
            setFormErrors({});
            setCity(profile.city);
            setState(profile.state);
        }
    }

    return <div>

        {<div className='d-flex align-center justify-content-between'>
            <span className='mb-1'>
            <p className='mb-0 mt-3'><strong>Location</strong></p>
          </span>
            <Link className='btnLink mb-3 fs-14' onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
        </div>}
        {editing ? <div className='d-flex justify-space-between align-center'>
            <div style={{marginTop: '8px', marginRight: '14px', width: '50%'}}>
                <p style={{marginBottom: '4px', fontWeight: '500'}}>City</p>
                <TextAreaInput errors={{}} name={'city'} value={city} onChange={(e) => setCity(e.target.value)}
                               type={'text'} placeholder={`${profile.city || ''}`}/>
            </div>
            <div style={{marginTop: '8px', marginRight: '14px', width: '50%'}}>
                <p style={{marginBottom: '4px', fontWeight: '500'}}>State</p>
                <TextAreaInput errors={{}} name={'state'} value={state} onChange={(e) => setState(e.target.value)}
                               type={'text'} placeholder={`${profile.state || ''}`}/>
            </div>
        </div> : <span className='text-muted d-block'>{profile.city || '-'}, {profile.state || '-'}</span>}
        <span className='form-error'>{formErrors.location}</span>
    </div>;
}


export const UploadResume = ({profile, session, refreshSession}) => {
    const [errorMessage, setErrorMessage] = useState(null)
    const [uploadErrors, setUploadErrors] = useState([])
    const [loading, setLoading] = useState(false)

    function onError() {
        setErrorMessage('Error saving changes, please try again')
        setLoading(false)
    }

    function uint8ArrayToBase64(uint8Array) {
        let binary = '';
        const len = uint8Array.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        return btoa(binary);
    }

    function handleDeleteResume() {
        setLoading(true)
        setErrorMessage(null)
        var prevImage = profile.resume.split('/')[2]
        deleteImageCDN(prevImage)

        Root.userApi.deleteResume(session.jwt)
            .then(() => refreshSession())
            .then(() => setLoading(false))
            .catch(() => {
                setErrorMessage('Error saving changes, please try again')
                setLoading(false)
            })
    }

    function onDrop(event) {
        setLoading(true)
        if (event.target.files.length > 0) {
            setErrorMessage(null)
            setUploadErrors([])
            const errors = validateFiles(event.target.files, 5242880, ['.pdf'])
            if (Object.keys(errors).length > 0) {
                setUploadErrors(errors)
                setLoading(false)
                return
            }

            if (profile.resume) {
                var prevImage = profile.resume.split('/')[2]
                deleteImageCDN(prevImage)
            }

            event.target.files[0].arrayBuffer()
                .then((buffer) => {
                    Root.userApi.updateProfileResume(uint8ArrayToBase64(new Uint8Array(buffer)), session.jwt)
                        .then(() => {
                            refreshSession()
                            setLoading(false);
                        })
                        .catch((err) => {
                            onError()
                        })
                })
        }
    }

    return <Card className={`xlCard`}>
        <Card.Body>
            <div>
                <div className='d-flex align-items-center justify-content-center'>
                    {profile.resume ? <Button className='btnLink' onClick={() => {
                            window.open(profile.resume, '_blank')
                        }}><RiFile2Fill style={{fontSize: '14px'}}/>{`Open resume in new tab`}</Button> :
                        <ImgUploader accept={"application/pdf"} buttonClassName='btnLink'
                                     buttonText={loading ? 'Uploading...' : `${profile.resume ? `${profile.firstName}'s` : 'Upload'} Resume (PDF)`}
                                     onDrop={onDrop}/>}
                    {profile.resume && <Button className='btnLink red' onClick={handleDeleteResume}><RiDeleteBin2Line
                        style={{fontSize: '14px'}}/> Delete Resume</Button>}
                </div>
                {errorMessage && <p style={{textAlign: 'center', margin: 0}} className='form-error'>{errorMessage}</p>}
                {uploadErrors.map((error, idx) => {
                    return <p key={idx} className='form-error' style={{textAlign: 'center', margin: 0}}>{error.type}</p>
                })}
            </div>
        </Card.Body>
    </Card>
}

export const EditFeatured = ({session}) => {
    const [featured, setFeatured] = useState(null)
    const [work, setWork] = useState({})
    const [editing, setEditing] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [error, setError] = useState(null)
    const handleCancel = () => {
        setEditing(false);
        setWork({});
    }

    useEffect(() => {
        getFeaturedWork()
    }, [])

    function validate() {
        const errors = {};
        if (!work.title) {
            push(errors, 'title', 'Title is required')
        }
        if (!work.url) {
            push(errors, 'url', 'URL is required')
        }
        return errors
    }

    const handleAdd = () => {
        setFormErrors({});

        var err = validate()
        if (Object.keys(err).length > 0) {
            setFormErrors(err)
            return;
        }

        setError(null)
        Root.userApi.addAttribute({attribute: "featured_work", newFeaturedWork: work}, session.jwt)
            .then(() => {
                getFeaturedWork()
                setWork({})
            }).catch(
            () => setError("Unable to add. Please try again later"))
    }

    function getFeaturedWork() {
        Root.userApi.getAttribute("featured_work", session.jwt)
            .then(res => setFeatured(res.data)).catch(
            () => setError("Something went wrong, please try again later"))
    }

    const handleEdit = () => {
        if (editing) {
            handleSave()
        } else {
            setEditing(true)
        }
    }

    function handleSave() {
        setError(null)
        setEditing(false)
    }

    function handleChange(event) {
        const {name, value} = event.target;
        setWork((prevState) => ({...prevState, [name]: value}));
    }

    const handleDelete = (id) => {
        setError(null)
        Root.userApi.removeAttribute("featured_work", id, session.jwt)
            .then((res) => getFeaturedWork()).catch(
            () => setError("Unable to delete. Please try again later"))
    }

    const Tile = ({work, idx}) => {
        return <div key={idx} className={`${s.editTile} mb-4`}>
      <span className='d-flex justify-content-between'>
      <a href={work.url} target='_blank' className='btnLink mb-1 fs-16'><FaLink/> {work.title}</a>
          {editing && <Button className='btnLink p-0' onClick={() => handleDelete(work.id)}><AiOutlineClose color={'red'}/></Button>}
      </span>
            <p className='text-muted mb-1 fs-13'>{work.description}</p>
        </div>
    }

    return <> <Card className={`xlCard`}>
        <Card.Body>
            <Link className='btnLink d-flex justify-content-end mb-3 fs-14'
                  onClick={handleEdit}>{editing ? 'Done' : 'Edit'}</Link>
            {featured ? featured.map((work, idx) => {
                return <Tile work={work} idx={idx}/>
            }) : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
            {editing && <>
                <TextInput containerClassName="mb-3" errors={formErrors} name="title" value={work.title || ''}
                           onChange={handleChange} label="Title" placeholder=""/>
                <TextAreaInput containerClassName="mb-3" errors={formErrors} name="description"
                               value={work.description || ''} onChange={handleChange} label="Description"
                               placeholder=""/>
                <TextInput containerClassName="mb-3" errors={formErrors} name="url" value={work.url || ''}
                           onChange={handleChange} label="URL" placeholder=""/>
                <p className='form-error'>{error}</p>
            </>}
        </Card.Body>
        {editing && <>
            <Card.Footer className=' d-flex justify-content-end'>
                <Button className='btnFill ms-2' onClick={handleAdd}>Add</Button>
            </Card.Footer>
        </>}
    </Card>
    </>
};
